var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{attrs:{"reloadImg":_vm.reloadImg,"screenSmall":_vm.mini},on:{"closeNav":function($event){_vm.mini = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }